export enum TipoFeriadoEnum {
  MUNICIPAL = "MUNICIPAL",
  ESTADUAL = "ESTADUAL",
  NACIONAL = "NACIONAL",
}
